import { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { X, Download } from 'lucide-react';

export default function PdfPreviewModal({ isOpen, onClose, pdfUrl, filename, onDownload }) {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen || !pdfUrl) return null;

  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      {/* Modal */}
      <div className="relative z-10 flex flex-col w-[95vw] h-[92vh] bg-[var(--surface-primary)] rounded-xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-[var(--border-primary)]">
          <h2 className="text-sm font-semibold text-[var(--text-primary)] truncate">{filename}</h2>
          <div className="flex items-center gap-2">
            <a
              href={pdfUrl}
              download={filename}
              onClick={onDownload}
              className="flex items-center gap-2 px-3 py-1.5 text-sm bg-cgiar-green text-white hover:bg-cgiar-green-dark rounded-lg transition-colors"
            >
              <Download className="w-4 h-4" />
              Download
            </a>
            <button
              onClick={onClose}
              className="p-1.5 hover:bg-[var(--surface-hover)] rounded-lg text-[var(--text-secondary)]"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* PDF Viewer */}
        <iframe
          src={pdfUrl}
          title="PDF Preview"
          className="flex-1 w-full border-0"
        />
      </div>
    </div>,
    document.body
  );
}
